import { render, staticRenderFns } from "./CSProcessingRequests.vue?vue&type=template&id=2f39939c&"
import script from "./CSProcessingRequests.vue?vue&type=script&lang=js&"
export * from "./CSProcessingRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports